/**
 * `S2-15` residual, `S2-FINDINGS-2` `M5` (`P2-CNW-058`): **who is wired to the settlements door.**
 *
 * `06` §6.1.5 row 26, `voirReglementsVentes`: `admin` oui, `resp` oui, `charge` oui, `relB` non, `relC`
 * non. The console's views are `admin`, `resp` and `collecte` (the chargé) for the three that hold it. The
 * composition root passed `readSettlements` to every view and the screen's own comment claimed the opposite;
 * a view without the right would have been refused by the api and drawn that refusal as an empty board.
 * Written once here so the wiring and the comment cannot drift apart.
 */
const VUES_REGLEMENTS: ReadonlySet<string> = new Set(["admin", "resp", "collecte"]);

export const holdsSettlementsRight = (vue: string): boolean => VUES_REGLEMENTS.has(vue);
